import { render, staticRenderFns } from "./AssetMonitoringCard.vue?vue&type=template&id=23448a8e&scoped=true&"
import script from "./AssetMonitoringCard.vue?vue&type=script&lang=js&"
export * from "./AssetMonitoringCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23448a8e",
  null
  
)

export default component.exports